<script>
import { mapState, mapActions } from 'vuex';
import LogoHeader from '../../components/onboarding/logo-header.vue';
import store from '../../store';
import { registerSegmentAnalytics } from '../../helpers/segment';

export default {
  name: 'GetStarted',
  components: {
    LogoHeader,
  },
  computed: {
    ...mapState({
      loading: (state) => state.onboarding.isUpdatingOnboarding,
      showOnboarding: (state) => state.login.showOnboarding,
    }),
  },
  watch: {
    showOnboarding(newValue) {
      if (!newValue) {
        this.$router.replace({ name: '/' });
      }
    },
  },
  methods: {
    ...mapActions(['setFormValue', 'updateOnboardingStep']),
    async handleContinue() {
      const nextPage = 'company-role';
      const response = await this.updateOnboardingStep(nextPage);
      if (!response) {
        // eslint-disable-next-line
        console.error('Error saving data. Please try again.');
        return;
      }
      this.$router.push({ name: nextPage });
    },
  },
  mounted() {
    // eslint-disable-next-line
    const { id, userName, email, name: teamName } = store.state.login;
    registerSegmentAnalytics({
      user_id: id,
      email,
      userName,
      teamName,
    });
  },
};
</script>

<template>
  <div id="main-container" class="container-fluid">
    <div class="row inner-container">
      <div class="col-6 panel">
        <logo-header />
        <div class="row">
          <div class="my-5 text-center">
            <h2 class="my-4">Let’s get you started for free</h2>

            <h5 class="text-muted my-5">
              You’ll be taken through a few questions to customize your experience.
            </h5>

            <b-button block variant="primary" size="lg" @click="handleContinue" :disabled="loading"
              >Get Started</b-button
            >

            <div class="mt-5">
              <h1 class="used-by-text">Used by 600+ happy teams!</h1>
              <img
                src="@/assets/team-logos.png"
                alt="Remote Teams"
                fluid
                width="100%"
                class="mt-2"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 panel light-blue">
        <b-progress :value="1" class="progress-container" />

        <div class="text-center mt-5">
          <img src="@/assets/onboarding-1.png" alt="Remote Teams" fluid width="100%" class="mt-5" />
        </div>
        <div class="card mt-5">
          <div class="card-body">✅ Organize team 1-1's automatically</div>
        </div>
        <div class="card mt-2">
          <div class="card-body">✅ Automate team introductions</div>
        </div>
        <div class="card mt-2">
          <div class="card-body">✅ The best value option for Slack</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#main-container .inner-container {
  min-height: 100vh;
}

.inner-container .panel {
  padding: 70px;
}

.inner-container .light-blue {
  background-color: #f4f7fc;
}

.used-by-text {
  color: #222e3f;
  font-weight: 600;
  line-height: 140%;
  font-size: 34px;
  font-style: italic;
}
</style>
